<template>
  <div class="events-list">
    <div class="events-list-container">
      <div class="cards-container" :style="{width: cardWidth * events.length + 'px'}">
        <currentcard v-for="(card,count) in events" :key="count" :attributes="card" />
      </div>
    </div>
    <!-- <div v-if="events.length > 1" class="gradient"></div> -->
  </div>
</template>

<script>
import currentcard from './currentcard.vue'
import {mapState} from 'vuex'
import _debounce from 'lodash/debounce'
import _sortBy from 'lodash/sortBy'
import {store} from '../store-constituency'

export default {
  props: ['attributes'],
  components: {
    currentcard
  },
  computed: {
    ...mapState(['eventsdata']),
    currentConstituency () {
      return store.currentConstituency
    }
  },
  data () {
    return {
      events: [],
      cardWidth: 280 + 10 // 10 padding
    }
  },
  watch: {
    eventsdata: function (newVal, oldVal) {
      if (!newVal) return
      this.getNewEvents()
    },
    'currentConstituency.name': function (newVal, oldVal) {
      this.getNewEvents()
    }
  },
  methods: {
    getNewEvents () {
      var events = []
      var futureEvents = []
      this.eventsdata.forEach((el, i) => {
        var filterConsituency = true
        if (this.currentConstituency && this.currentConstituency.name) {
          if (!el.constituency) {
            filterConsituency = false
          } else if (!el.constituency.includes(this.currentConstituency.name)) {
            filterConsituency = false
          }
        }
        if (filterConsituency) {
        // if (!el.constituency || filterConsituency) {
          var priority = '1'
          if (['happening now', 'today'].includes(el.noun)) {
            switch (el.noun) {
              case 'today':
                priority = '2'
                if (el.end && new Date() >= new Date(el.end)) {
                  priority = '2b'
                }
                break
              case 'tomorrow':
                priority = '3'
                break
            }
            events.push({...el, priority})
          }
          // else if (new Date(el.start) > new Date() && futureEvents.length < 5) {
          //   // if empty get 5 of future dates
          //   futureEvents.push(el)
          // }
        }
      })
      if (events.length) {
        events = _sortBy(events, 'priority')
      } else {
        if (futureEvents.length) {
          events = _sortBy(futureEvents, 'start')
        }
        // else {
        //   // if empty get 5 of future dates just get the last 5 events
        //   events = this.eventsdata.slice(-5)
        //   events = _sortBy(events, 'start')
        // }
      }
      this.events = events
      this.adjustContainer()
    },
    resizeCard () {
      if (document.documentElement.clientWidth >= 960) {
        this.cardWidth = 350 + 10 // 10 padding
      } else {
        this.cardWidth = 280 + 10 // 10 padding
      }
    },
    adjustContainer () {
      if (this.events.length < 3) {
        this.$el.closest('div.component-content').classList.remove('container')
        this.$el.closest('div.component-content').classList.add('inline')
      } else {
        this.$el.closest('div.component-content').classList.remove('inline')
        this.$el.closest('div.component-content').classList.add('container')
      }
      if (!this.events.length) {
        this.$el.closest('div.component-currentevents').classList.add('none')
      } else {
        this.$el.closest('div.component-currentevents').classList.remove('none')
      }
    }
  },
  mounted () {
    const self = this
    window.addEventListener('resize', _debounce(function () {
      self.resizeCard()
    }, 100))
    self.resizeCard()
  }
}
</script>

<style lang="scss" scoped>
.events-list {
  position: relative;

  .events-list-container {
    width: 100%;
    overflow: auto;
    /* background-color: $greydark; */
    padding-bottom: 10px;
    .cards-container {
      width: 400vw;
    }
  }
  .gradient {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 40px;
    height: 100%;
    background: linear-gradient(90deg,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,0) 50%,$greylight);
  }
}
</style>
